import React, { useEffect } from "react";
import { logoutCall } from "../../api/user";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { resetRedux, checkNonQADomain, checkImpersonateUser, removeTheToken
 } from "../../util/util";
import { onCloseRevealRedirectionLink, handleOnCloseEvent } from "../../util/helpURLNavigation";
import { pendoTrack } from "../../util/pendoUtil";
import { removeChat } from "../../util/chatBotUtils";
import CPFallbackPage from "./CPFallbackPage";
import { useAuth0 } from "@auth0/auth0-react";
import { REDBALL_FEATURE_TOGGLE } from "../../constants/appConstants";
import PropTypes from "prop-types";

function LogoutPage(props) {
  const { logout } = useAuth0();
  const nonQADomain = checkNonQADomain()
  const { t } = useTranslation("loginTranslation");
  const handleClose = () => {
    sessionStorage.clear();
    handleOnCloseEvent(onCloseRevealRedirectionLink());
  };
  const normalLogout = () => {
    logoutCall()
      .then((response) => {
        resetItems();
        pendoTrack("Customer Portal | Logout ", {
          status: "Success",
          statusCode: response.data.statusCode,
          accountId: props.accountNumber,
        });
        handleClose(); // to handle the fleetcare logout to avoid the loader issue 
      })
      .catch((error) => {
        resetItems();
        pendoTrack("Customer Portal | Logout", {
          status: "Failed",
          statusCode: error.response.data.statusCode,
          accountId: props.accountNumber,
        });
        handleClose(); // to handle the fleetcare logout to avoid the loader issue 
      });
  };
  
  const auth0Logout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
    pendoTrack("Customer Portal | Logout ", {
      status: "Success",
      accountId: props.accountNumber,
    });
    resetItems();
  }

  const resetItems = () =>{
    removeTheToken();
    resetRedux();
    sessionStorage.clear();  
  }

  useEffect(() => {
    removeChat(props.regionId, props.emailAddress);
  }, []);

  useEffect(() => {
    if (props.logoutState === true) {
      if (REDBALL_FEATURE_TOGGLE && nonQADomain) {
        checkImpersonateUser() ? normalLogout() : auth0Logout();
      } else {
        normalLogout();
      }
    }
  }, [props.logoutState]);

  useEffect(() => {
    document.title = t(`${props.title}`);
  }, [props.title]);

  return (
      <CPFallbackPage
        windowSize={props.windowSize.width}
        ariaLabel="Logout Successful"
        pageTitle={t("Logout successful")}
        buttonId="goto-reveal-link"
        buttonHandler={() => handleClose()}
        buttonName={t("Close")}
        buttonAriaLabel="Close"
      />
  );
}

LogoutPage.propTypes = {
  accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  logoutState: PropTypes.bool,
  windowSize: PropTypes.object,
  emailAddress: PropTypes.string,
  regionId: PropTypes.string,
  title: PropTypes.string,
};

export default connect(
  (state) => ({
    logoutState: state.ACCOUNT.logout,
    windowSize: state.ACCOUNT.windowSize,
    accountNumber: state.ACCOUNT.accountNumber,
    emailAddress: state.ACCOUNT.emailAddress,
    regionId: state.ACCOUNT.regionId,
  }),
  null
)(LogoutPage);